import { useState, useEffect } from "react";
import { Button, Grid } from "@mui/material";
import styles from "./styles.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Loader from "components/utils/Loading";
import CustomTextField from "components/utils/CustomFields/CustomTextField";
import { toast } from "react-hot-toast";
import machineService from "services/MachineService";
import ShopsHelper from "helpers/ShopsHelper";

function AddLabelScalePopup({ open, onClose, machineToEdit = null }) {
  const [name, setName] = useState("");
  const [macId, setMacId] = useState("");
  const [machineNo, setMachineNo] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (machineToEdit) {
      setName(machineToEdit.machine_name || "");
      setMacId(machineToEdit.mac_id || "");
      setMachineNo(machineToEdit.machine_number ?? "");
    } else {
      setName("");
      setMacId("");
      setMachineNo("");
    }
  }, [machineToEdit, open]);

  if (!open) return null;

  const handleSave = async () => {
    if (!name.trim() || !macId.trim()) {
      toast.error("Please enter Machine name and MAC ID");
      return;
    }

    setIsLoading(true);
    try {
      const machineData = {
        machine_name: name.trim(),
        mac_id: macId.trim().toUpperCase(),
        machine_number: Number(machineNo) || 0,
        active: true,
      };

      if (machineToEdit && machineToEdit.id) {
        await machineService.updateMachine(machineToEdit.id, machineData);
        toast.success("Machine updated successfully");
      } else {
        await machineService.addMachine(machineData);
        toast.success("Machine registered successfully");
      }

      await ShopsHelper.saveMachineToShopProfileConfig(machineData, machineToEdit);

      onClose();
    } catch (error) {
      toast.error(error.message || "Failed to save machine");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.popupOverlay}>
      <Loader isOpen={isLoading} />
      <div className={styles.popupContainer}>
        <div className={styles.headerSection} style={{ paddingBottom: "15px" }}>
          <div>
            <h2>{machineToEdit ? "Edit Machine" : "New Machine"}</h2>
            <h4>{machineToEdit ? "Update label scale settings" : "Register a new label printer for your setup"}</h4>
          </div>
          <CloseRoundedIcon onClick={onClose} className={styles.icon} />
        </div>

        <Grid container className={styles.CategoryWrapper}>
          <Grid item xs={12} className={styles.textFieldArea}>
            <CustomTextField fullWidth label="Machine name" value={name} onChange={(e) => setName(e.target.value)} />
          </Grid>
          <Grid item xs={12} className={styles.textFieldArea}>
            <CustomTextField
              fullWidth
              label="MAC ID"
              value={macId}
              onChange={(e) => setMacId(e.target.value.toUpperCase())}
            />
          </Grid>
          <Grid item xs={12} className={styles.textFieldArea}>
            <CustomTextField
              fullWidth
              label="Machine number"
              value={machineNo}
              onChange={(e) => setMachineNo(e.target.value)}
            />
          </Grid>
        </Grid>

        <div className={styles.actionButtons}>
          <Button onClick={onClose} className={styles.buttonGray}>
            Cancel
          </Button>
          <Button onClick={handleSave} className={styles.buttonRed}>
            {machineToEdit ? "Save" : "Create"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AddLabelScalePopup;
